import { useSlugs } from "../../core/hooks/useSlugs";
import { useLocations } from "../../core/hooks/useLocations";
import { useAuthorizedLocations } from "../../core/hooks/useAuthorizedLocations";
import { Module } from "../../ui/components/Module";
import { Trans } from "react-i18next";
import { ReactNode } from "react";
import { useContextLocation } from "../../core/hooks/useContextLocation";

export const LocationGuard = ({children}: {children: ReactNode}) => {
  const {brandSlug, locationSlug} = useSlugs();
  const locations = useLocations(brandSlug);
  const authorizedLocations = useAuthorizedLocations(brandSlug);
  const location = locations
    ?.find(l => l.urlSlug === locationSlug);
  const authorizedLocation = authorizedLocations
    ?.find(l => l.urlSlug === locationSlug);
  const contextLocation = useContextLocation();

  if (!locations || !contextLocation) {
    return null;
  }

  if (!location) {
    return (
      <Module>
        <Trans>Location invalid</Trans>
      </Module>
    );
  }

  if (!authorizedLocation) {
    return (
      <Module>
        <Trans>Location not authorized</Trans>
      </Module>
    );
  }

  return <>{children}</>;
};
